import React from 'react';
export const FilterBuilderContext = React.createContext({});
